//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

/**
 * This is the typing for the different sources within the content-detail-page infrastructure.
 * This also exists as a ContentSourceTypes angular constant, but has been changed on the TS side
 * to match our typical enum naming patterns.
 */
enum ContentSourceType {
  BUSINESS_USER = 'business-user',
  HASHTAG = 'hashtag',
  LINK = 'link',
  MENTION = 'mention',
  USER = 'user',
}

export default ContentSourceType;
